import React, { useContext } from 'react';
import { ActualIconProps } from 'mobx/commonTypes';
import { useTheme } from '@mui/material/styles';
import { UiContext } from 'uiContext';
import { defaultSpacingPresets } from 'hooks/useGetSpacing';

export default function IconSunCloudy({
  style,
  extColor,
  isAutoscallable = true,
  sizeKey = '32x32',
}: ActualIconProps) {
  const theme = useTheme();
  const fill = extColor || theme.palette.customBackgrounds.contrast;
  const {
    spacings: {
      icons: { [sizeKey]: size },
    },
  } = useContext(UiContext);

  const w = isAutoscallable ? size.w : defaultSpacingPresets.icons[sizeKey].w;
  const h = isAutoscallable ? size.h : defaultSpacingPresets.icons[sizeKey].h;

  return (
    <svg
      style={style}
      width={w}
      height={h}
      viewBox="0 0 32 32"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.7603 14.907C18.7131 14.907 18.6678 14.9124 18.6207 14.9142C18.0981 12.7051 16.1181 11.0592 13.7498 11.0592C11.2592 11.0592 9.20044 12.8769 8.81089 15.2536C8.50009 15.1677 8.17258 15.1176 7.83552 15.1176C6.11207 15.1176 4.67198 16.3208 4.3051 17.9327C2.95568 18.4613 2 19.7701 2 21.3063C2 23.3077 3.62383 24.9292 5.62468 24.9292H18.7609C21.5295 24.9292 23.7719 22.6867 23.7719 19.9193C23.7719 17.1518 21.5295 14.907 18.7609 14.907H18.7603Z"
        fill="white"
      />
      <path
        d="M23.216 10.1811C21.5653 10.1811 20.2284 11.5198 20.2284 13.1692C20.2284 13.3685 20.2493 13.5642 20.2869 13.7545C21.7198 14.1088 22.9618 14.9494 23.8268 16.093C25.184 15.8114 26.2035 14.6087 26.2035 13.1686C26.2035 11.5186 24.8666 10.1805 23.216 10.1805V10.1811Z"
        fill="white"
      />
      <path
        d="M23.6765 6.38635H22.7554V8.45819H23.6765V6.38635Z"
        fill="white"
      />
      <path
        d="M20.2105 9.51173L18.7453 8.04718L18.0945 8.69802L19.559 10.1644L20.2105 9.51173Z"
        fill="white"
      />
      <path
        d="M26.2215 16.8249L27.6878 18.2901L28.3387 17.6398L26.8729 16.1747L26.2215 16.8249Z"
        fill="white"
      />
      <path d="M30 12.7087H27.927V13.6298H30V12.7087Z" fill="white" />
      <path
        d="M28.3387 8.69801L27.6878 8.04657L26.2215 9.51231L26.8729 10.1643L28.3387 8.69801Z"
        fill="white"
      />
    </svg>
  );
}
